<script lang="ts">
  /** A text label on the phone's read-only canvas (ma-inzp): same look as TextLabelNode, no editing. */
  import type { NodeProps } from '@xyflow/svelte';
  import type { BoardItemStyle } from '../../lib/types';

  type Props = NodeProps & { data: { content: string; style: BoardItemStyle } };

  let { data, width, height }: Props = $props();

  let style = $derived(data.style ?? {});
</script>

<div
  class="text-node"
  style="
    width: {width ? `${width}px` : 'auto'};
    height: {height ? `${height}px` : 'auto'};
    color: {style.textColor ?? '#1f2937'};
    background: {style.fill ?? 'transparent'};
    border-color: {style.stroke ?? 'transparent'};
    font-size: {style.fontSize ?? '16'}px;
    font-weight: {style.fontWeight ?? '500'};
    font-style: {style.fontStyle ?? 'normal'};
    text-align: {style.textAlign ?? 'left'};
    justify-content: {style.verticalAlign ?? 'center'};
  "
>
  <span class="text-display">{data.content}</span>
</div>

<style>
  .text-node {
    display: flex;
    flex-direction: column;
    min-width: 60px;
    min-height: 28px;
    padding: 0.25rem 0.375rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    box-sizing: border-box;
    line-height: 1.35;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .text-display {
    display: block;
    width: 100%;
  }
</style>
